import type { Breakpoint } from '../types/breakpoints';

// These values mirror breakpoints.css (@theme) and packages/ui/src/themes/variables/screens.ts.
// Prefer reading CSS variables at runtime via getCssVariable() — that is the source of truth.
// Use these constants only when the DOM is not yet available or CSS hasn't been applied
// (e.g. as a fallback for race conditions during hydration).
export const BREAKPOINTS: Record<Breakpoint, string> = {
  '--breakpoint-xs': '360px',
  '--breakpoint-sm': '480px',
  '--breakpoint-md': '768px',
  '--breakpoint-lg': '992px',
  '--breakpoint-xl': '1260px',
  '--breakpoint-2xl': '1440px',
};
